import {BsFillStarFill} from 'react-icons/bs'

import './index.css'

const BookItem = props => {
  const {bookDetails} = props
  const {title, coverPic, authorName, rating, readStatus} = bookDetails

  return (
    <li className="book-list-item">
      <img className="book-cover-pic" src={coverPic} alt={title} />
      <div className="book-details-container">
        <h1 className="book-title">{title}</h1>
        <p className="book-author-name">{authorName}</p>
        <div className="book-rating-container">
          <p className="book-rating-para">Avg Rating</p>
          <BsFillStarFill className="star-logo" color="#FBBF24" size={16} />
          <p className="book-rating">{rating}</p>
        </div>
        <p className="book-status-para">
          Status : <span className="book-status">{readStatus}</span>
        </p>
      </div>
    </li>
  )
}
export default BookItem
